// 导入组件，组件必须声明 name
import yStandardSelector from "./src/index.vue";
// 为组件提供 install 安装方法，供按需引入
yStandardSelector.install = function (Vue) {
  Vue.component(yStandardSelector.name, yStandardSelector);
};
// 默认导出组件
export default yStandardSelector;